/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

import { LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT, SET_CLIENT_CONFIGURATION } from '../actions/actionTypes';
let config = require('../config/' + process.env.NODE_ENV);

const loginInit = {
  user: null,
  error: null,
  clientConfiguration: {
    SSOLogoutUrl: config.SSOLogoutUrl,
    idPortalUrl: null,
    idPortalApiUrl: null,
    idPortalClientId: null,
    accessToken: null
  }
};

const loginReducer = (state = loginInit, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return Object.assign({}, state, { user: action.payload.user, error: null });
    case LOGIN_ERROR:
      return Object.assign({}, state, { user: null }, action.payload);
    case SET_CLIENT_CONFIGURATION:
      return Object.assign({}, state, { clientConfiguration: action.payload.data });
    default:
      return state;
  }
};

const logoutReducer = (state = loginInit, action) => {
  switch (action.type) {
    case LOGOUT:
      return Object.assign({}, state, { user: null, error: null });

    default:
      return state;
  }
};

export { loginReducer, logoutReducer };
